import {React, useEffect, useState, useContext} from 'react'
import RuralAndUrbanConsumerRetailPriceData from '../../../../Components/RuralAndUrbanConsumerRetailPriceData'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import {shortMonthToFull,handleUserLevelAccessPermissions,getAllYears,validateRoles,validateMonthYears} from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';


function UrbanConsumerRetailPrice() {

    const [districtList, setDistrictList] = useState([]);
    const [years, setYears] = useState([]);
    const [months, setMonth] = useState([]);
    const [districtCode, setDistrictCode] = useState('');
    const [yearName, setYearName] = useState('');
    const [monthName, setMonthName] = useState('');
    const [urbanConsumerPrice, setUrbanConsumerPrice] = useState([]);
    const [payload, setPayload] = useState([]);
    const [isDivision, setIsDivision ] = useState(false);
    const [isDistrict, setIsDistrict] = useState(false);
    const [buttonAccess, setButtonAccess] =  useState({userLevel:'',roles:'',isVisible:false});
    const token = useContext(MyContextProvider).token;
    const decode_token =jwtDecode(token)
    const navigate = useNavigate();
    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };


    useEffect(() => {
        
      const level =  handleUserLevelAccessPermissions(decode_token);
      setButtonAccess(level)

      // get District By Division ID
      const getDistrictListByDivision = async () => {
        try {
          const response =  await axios.post(
            `${API_URL}api/geDistrictListByDivisionId`,
            { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config );
          const allDistrict = response.data;
         
         if (allDistrict.status) {
              setDistrictList(allDistrict.data);
              showLoading(false);
          }
          } catch (error) {
          console.error(error);
          showLoading(false);
          }
        }



       // All district list
        const getDistrictList = async () => {
        
            try {
            const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
            const allDistrict = response.data;
    
            if (allDistrict.status) {
                setDistrictList(allDistrict.data);
                showLoading(false);
            }
            } catch (error) {
            console.error(error);
            showLoading(false);
            }
        };

      // Set district for district level user
      const setDistrictForDistrictLevel = () => {
        const districtCode = decode_token.id.USER_LEVEL_LOCATION;
        const districtName = decode_token.id.LOCATION_NAME;
        
        // Create a single district object for the dropdown
        const singleDistrict = [{
          DISTRICT_CODE: districtCode,
          DISTRICT_NAME: districtName
        }];
        
        setDistrictList(singleDistrict);
        setDistrictCode(districtCode);
        setIsDistrict(true);
        showLoading(false);
      };

      //Get all Months data    
     const getMonthsList = (e) => { 
        showLoading(true)
            axios
              .get(`${API_URL}api/graph/getMonths/2019`, config)
              .then((res) => {
                let monthDataResponse = res.data;
                if (monthDataResponse.status) {
                  setMonth(monthDataResponse.data);
                  showLoading(false)
                }
              })
              .catch((err) => {
                console.error(err);
               showLoading(false);
              });
          }


      const getYearList =()=>{
            setYears(getAllYears());
          }

      const pageLoadUrbanConsumerPrice=()=>{
        showLoading(true);
          axios
          .get(`${API_URL}api/consumerRetail/getUrbanConsumerPriceInputForm`, config)
          .then((res) => {
             let allData = res.data;
            if (allData.status) {
              setUrbanConsumerPrice(allData.data[0].GroupCodes);
              setTimeout(()=>(showLoading(false)),3000)
             }
          }).catch((err)=>{
              console.log(err)
              showLoading(false);
          } );
      }


      const userRole = async () => {
        showLoading(true)
        try {
          const role = await validateRoles(decode_token)
          if (role) {
            
                pageLoadUrbanConsumerPrice(); 
                // urbanConsumerPriceInputFormDataUnitList();
                getYearList();
                getMonthsList();
      
                if(level.userLevel==='DIVISION LEVEL' && level.roles.includes('DIVADM')){
                  getDistrictListByDivision()
                  setIsDivision(true)
                }else if(level.userLevel==='DISTRICT LEVEL'){
                  setDistrictForDistrictLevel()
                }else{
                    getDistrictList()
              }

         }else {
        
            alert("You are not an authorized user to capture the data for Pricing");
            navigate("/dashboard");
          }
        } catch (error) {
          console.log(error);
          showLoading(false)
        }
      }
  
  
      userRole();

       
    },[]);
  
 
    const handleDropdownChange=(e)=>{
         
         switch(e.target.name){
          case 'district_name':
                setDistrictCode(e.target.value)
                setMonthName('')
                setYearName('')
          break;
          case 'month_name':
                setMonthName(e.target.value)
                setYearName('')
          break;
          case 'year_name':

                  if(!validateMonthYears(e.target.value,monthName)){
                    setMonthName('')
                    setYearName('')
                    return;
                  }
              
                  if(districtCode===''){
                    toast.error(messages.DISTRICT_MSG, messages.COLOR_RED);
                    setYearName('')
                    return;
                  }
              
                if(monthName===''){
                  toast.error(messages.MONTH_MSG, messages.COLOR_RED);
                  setYearName('')
                    return;
                }
                  setYearName(e.target.value)
                  let postData={
                    "district_code": districtCode,
                    "month_name": monthName,
                    "year_name": e.target.value
                  }
                    onChangeUrbanConsumerPriceData(postData)

                  
          break;
          default:
            console.log("switch case are not match");
         break;

         }
}

    const onChangeUrbanConsumerPriceData= async (postData)=>{
      showLoading(true)
      
          try {
           
            const response = await axios.post(`${API_URL}api/consumerRetail/getUrbanConsumerPriceInputFormPopulateData`, postData,config);
            if(response.data.status){
              setUrbanConsumerPrice(response.data.data[0].GroupCodes);
              setPayload(response.data.data[1].payload)
              showLoading(false)
            }
           
          } catch (error) {
            console.error('Error posting data:', error);
            showLoading(false)
          }

    }
    const resetMothAndYearField=()=>{
      setMonthName('')
      setYearName('')
      // Don't reset district code for district level users
      if(!isDistrict){
        setDistrictCode('')
      }
    }
  

    const storedLanguage = localStorage.getItem('language');

  return (
    <>
   <ToastContainer/>
   <GlobalLoading />
     <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
       <div className="card-body pb-1">
        <div className="row align-items-center">
            <h4 className="page_heading">
            {storedLanguage === 'hi' ? titlesData.hi.URBAN_CONSUMER_PRICE_INPUT_FORM : titlesData.en.URBAN_CONSUMER_PRICE_INPUT_FORM}</h4>
            <div className="row align-items-center">
            {isDivision &&
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                 </div>
            }
            {isDistrict &&
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT} </label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                 </div>
            }
            {!isDistrict &&
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                    <select
                     name="district_name"
                     id="district_name"
                     className="form-select"
                    onChange={handleDropdownChange}
                    value={districtCode}
                   >
                  <option value="" disabled>Select District</option>
                  {districtList &&
                    districtList
                      .slice()
                      .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                      .map((ele, index) => (
                        <option key={index} value={ele.DISTRICT_CODE}>
                          {ele.DISTRICT_NAME}
                        </option>
                      ))}
                </select>
                </div>
            }

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                 <select  name="month_name"
                  className="form-select"  
                  onChange={handleDropdownChange} 
                  value={monthName}
                  >
                    <option value="" disabled>Select Month</option>
                      {months && months.map((ele, i) => (
                        <option key={i} value={ele.MONTH}>
                        {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
                    <select  name="year_name" 
                     className="form-select" 
                     onChange={handleDropdownChange}  
                      value={yearName} >
                        <option value="" disabled>Select Year</option>
                        {years && years.map((ele, index) => (
                          <option key={index} value={ele}>
                          {ele}
                          </option>
                        )) }
                  </select>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div className="card mx-3 mb-3">
        {
           urbanConsumerPrice.length > 0 && 
           <RuralAndUrbanConsumerRetailPriceData 
            type="urban" 
            payload={payload} 
            districtCode={districtCode}
            config={config}
            resetMothAndYearField={resetMothAndYearField}
            userInfoObject={buttonAccess}  
            yearName={yearName} 
            monthName={monthName}
            blockCode=''
           // unitData={UrbanConsumerPriceInputFormDataUnitList} 
            urbanAndRuralCommonItemPrice={urbanConsumerPrice}
            url="UrbanConsumerRetailPriceInputFormDataSaveToDB"

           />
       
        }
   </div>
    </div>
   
    </>
  )
}

export default UrbanConsumerRetailPrice
